import * as Sentry from '@sentry/nuxt';

Sentry.init({
  // If set up, you can use your runtime config here
  dsn: "https://1c757c5b71e84514b45a6d91ad7fda40@sentry.yektanet.tech//236",
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
  environment: useRuntimeConfig().public.ENV || process.env.NODE_ENV
});
